import React from 'react'
import ReactTooltip from 'react-tooltip';

import Check from "../components/check.js";
import Tooltipps from '../components/tooltips.js';
import Description from "../components/partial.description.js";

const IndexPage = () => (
  <div>
    <Description />

    <Check />

    <section className="desc">
      Zögern Sie nicht, uns zu <a href="http://www.solmecke.eu/kontakt">kontaktieren</a>. 
      Wir verhelfen Ihnen gerne zu Ihrem Recht.
    </section>

    <Tooltipps />
  </div>
);

export default IndexPage



// WEBPACK FOOTER //
// ./src/pages/index.js